import { Component, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, map } from 'rxjs';

import { SessionSyncService } from './core/session/session-sync.service';
import { SessionTimeoutComponent } from './core/session/session-timeout/session-timeout';
import { AuthenticationService } from './shared/services/auth/authentication.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SessionTimeoutComponent],
  templateUrl: './app.html',
})
export class App {
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);
  readonly #authenticationService = inject(AuthenticationService);
  readonly #sessionSyncService = inject(SessionSyncService);

  protected readonly title = signal('khts-asset-agent-web-client');

  readonly #currentUrl = toSignal(
    this.#router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects.split('?')[0]),
    ),
    { initialValue: '/' },
  );

  constructor() {
    // Redirect to the returnUrl after login
    effect(() => {
      if (this.#authenticationService.isAuthenticated()) {
        const returnUrl = this.#route.snapshot.queryParamMap.get('returnUrl');
        if (returnUrl) {
          void this.#router.navigateByUrl(returnUrl, {
            replaceUrl: true,
          });
        }
      }
    });

    effect(() => {
      if (this.#sessionSyncService.isRedirectedFromIdp()) {
        if (this.#currentUrl() !== '/auth/logged-out') {
          this.#authenticationService.forceLogoutRedirect();
        }
      }
    });

    effect(() => {
      if (this.#sessionSyncService.goToHomeSync()) {
        this.#sessionSyncService.broadcastMessage({
          type: 'HOME',
          shouldRedirect: false,
        });
        void this.#router.navigateByUrl('/', { replaceUrl: true });
      }
    });
  }
}
